import React from 'react';
import useFetch from '../../../../components/hooks/useFetch.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import {
  SISTEMA_EXCLUIR
} from '../../../../services/permissoesRecebidas.js';

function FormExcluirSistema({
  acaoCancelar,
  acaoFechar,
  permissaoRecebidaSelecionada,
  idCorreios,
  idCorreiosPJ,
}) {
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      SISTEMA_EXCLUIR(idCorreios, idCorreiosPJ, permissaoRecebidaSelecionada.id),
    );

    if (response.ok) {
      abreAlertaDialog('Sistema excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{permissaoRecebidaSelecionada?.iprojTi.nome}"</h2>
        </div>
        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse sistema?
        </div>
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirSistema;
